<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import TermsCheckbox from '@uiKit/components/TermsCheckbox.vue'
import SellNote from './SellNote.vue'
import { DIVIDEND_NOTICE } from '../constants/sellCopy'

// Sell — Dividend-timing notice (spec 1.7.3). It must be acknowledged before
// the quantity step: rental entitlement follows whoever holds the tokens at
// 00:00 on the 1st of the month.

const isAcknowledged = defineModel<boolean>({ required: true })
</script>

<template>
  <Box direction="col" gap="4">
    <Text
      is="h3"
      type="caption"
      weight="bold"
      color="var(--p-sliceal-gray-400)"
      class="sell-dividend__eyebrow"
      >RENTAL INCOME</Text
    >

    <SellNote
      tone="info"
      icon="calendar"
      :title="DIVIDEND_NOTICE.title"
      :text="DIVIDEND_NOTICE.text"
    />

    <Box class="sell-dividend__ack">
      <TermsCheckbox v-model="isAcknowledged" size="lg">
        <Text is="span" type="caption" color="var(--p-text-muted-color)" style="line-height: 1.5">{{
          DIVIDEND_NOTICE.acknowledgement
        }}</Text>
      </TermsCheckbox>
    </Box>
  </Box>
</template>

<style scoped>
.sell-dividend__eyebrow {
  margin: 0;
  line-height: 1.4;
}

.sell-dividend__ack {
  min-height: 44px;
  padding: 12px 14px;
  border: 1px solid var(--p-sliceal-gray-200);
  border-radius: 16px;
  background: var(--p-surface-0);
}
</style>
